<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>fingerprint</mat-icon></div>
    <div class="fe-header-text">
      <h2 class="cf-dlg-title">Factura electrónica</h2>
      <p class="cf-dlg-subtitle">{{ invoiceNumber }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="generating" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="!generating; else generatingTpl">
    <div class="cf-dlg-body">
    <ng-container *ngIf="responseModel !== undefined">
      <div class="fe-notice fe-notice--warn">
        <mat-icon>warning</mat-icon>
        <span>Completa los siguientes campos para poder generar la factura.</span>
      </div>

      <div class="fe-section">
        <div class="fe-section__title">
          <mat-icon>person</mat-icon> Mi cuenta
        </div>
        <ul class="fe-errors">
          <li *ngIf="responseModel.contactSellerRequiresSpainCountry">El campo "País" no puede ser distinto a España.</li>
          <li *ngIf="responseModel.contactSellerRequiresResidenceType">Selecciona un "Tipo de residencia" en Mi cuenta.</li>
          <li *ngIf="responseModel.contactSellerRequiresCompanyNameLength">El campo "Razón social" debe tener mínimo 2 palabras.</li>
          <li *ngIf="responseModel.contactSellerRequiresCorporateNameLength">El campo "Razón social" debe tener máximo 80 caracteres.</li>
          <li *ngIf="responseModel.contactSellerRequiresAddressLength">El campo "Dirección" no puede tener más de 80 caracteres.</li>
          <li *ngIf="responseModel.contactSellerRequiresPostalCodeLength">El campo "Código postal" no puede tener más de 5 caracteres o es requerido.</li>
          <li *ngIf="responseModel.contactSellerRequiresLocationLength">El campo "Municipio" no puede tener más de 50 caracteres.</li>
          <li *ngIf="responseModel.contactSellerRequiresStateLength">El campo "Provincia" no puede tener más de 20 caracteres.</li>
        </ul>
      </div>

      <div class="fe-section">
        <div class="fe-section__title">
          <mat-icon>contacts</mat-icon> Contacto
        </div>
        <ul class="fe-errors">
          <li *ngIf="responseModel.contactBuyerRequiresFace">Es necesario rellenar los datos FACE del Contacto.</li>
          <li *ngIf="responseModel.contactBuyerRequiresSpainCountry">El campo "País" no puede ser distinto a España.</li>
          <li *ngIf="responseModel.contactBuyerRequiresResidenceType">Selecciona un "Tipo de residencia" en el Contacto.</li>
          <li *ngIf="responseModel.contactBuyerRequiresCompanyNameLength">El campo "Nombre / Razón social" debe tener mínimo 2 palabras.</li>
          <li *ngIf="responseModel.contactBuyerRequiresCorporateNameLength">El campo "Nombre / Razón social" debe tener máximo 80 caracteres.</li>
          <li *ngIf="responseModel.contactBuyerRequiresAddress">El campo "Dirección" no puede estar vacío.</li>
          <li *ngIf="responseModel.contactBuyerRequiresPostalCode">El campo "Código postal" no puede estar vacío.</li>
          <li *ngIf="responseModel.contactBuyerRequiresLocation">El campo "Localidad" no puede estar vacía.</li>
          <li *ngIf="responseModel.contactBuyerRequiresState">El campo "Provincia" no puede estar vacía.</li>
          <li *ngIf="responseModel.contactBuyerRequiresAddressLength">El campo "Dirección" no puede tener más de 80 caracteres.</li>
          <li *ngIf="responseModel.contactBuyerRequiresPostalCodeLength">El campo "Código postal" no puede tener más de 5 caracteres.</li>
          <li *ngIf="responseModel.contactBuyerRequiresLocationLength">El campo "Localidad" no puede tener más de 50 caracteres.</li>
          <li *ngIf="responseModel.contactBuyerRequiresStateLength">El campo "Provincia" no puede tener más de 20 caracteres.</li>
        </ul>
      </div>
    </ng-container>


      <ng-container *ngIf="responseModel === undefined">
        <div class="fe-options">
          <label class="fe-option">
            <mat-checkbox [(ngModel)]="hasCertificate" color="primary">
              Firmar factura electrónica
            </mat-checkbox>
            <span class="fe-option__hint">Adjunta tu certificado digital (.pfx / .p12) para firmar el fichero.</span>
          </label>

          <label class="fe-option">
            <mat-checkbox [(ngModel)]="hasDIR3" color="primary">
              Factura para entidad pública o administración
            </mat-checkbox>
            <span class="fe-option__hint">Actívalo si el destinatario es un organismo público (código DIR3).</span>
          </label>
        </div>

        <div class="fe-cert" *ngIf="hasCertificate">
          <div class="fe-cert__title">
            <mat-icon>lock</mat-icon>
            <span>Certificado electrónico</span>
          </div>

          <div class="fe-file-wrap" [class.cf-field--invalid]="submitted && !file">
            <label class="fe-file-label" for="certFile">
              <mat-icon>attach_file</mat-icon>
              <span>{{ file ? file.name : 'Seleccionar certificado (.pfx / .p12)' }}</span>
            </label>
            <input id="certFile" type="file" class="fe-file-input" (change)="fileChange($event)" accept=".pfx,.p12">
            <div class="cf-field__error fe-file-error" *ngIf="submitted && !file"><mat-icon>error</mat-icon> Selecciona tu certificado</div>
          </div>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Contraseña del certificado</mat-label>
            <input matInput [type]="showPassword ? 'text' : 'password'" [(ngModel)]="certPassword" name="certPassword" autocomplete="off">
            <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
              <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </ng-container>
    </div>

    <div class="cf-dlg-footer">
      <button *ngIf="responseModel !== undefined" mat-stroked-button class="cf-dlg-btn-secondary" (click)="responseModel = undefined">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">{{ responseModel === undefined ? 'Cancelar' : 'Cerrar' }}</button>
      <button *ngIf="responseModel === undefined" mat-flat-button class="cf-dlg-btn-primary" (click)="save()">
        <mat-icon>file_download</mat-icon> Generar
      </button>
    </div>
  </ng-container>

  <ng-template #generatingTpl>
    <app-loading-state message="Generando factura electrónica…"></app-loading-state>
  </ng-template>
</div>
